import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

export function SelectListFilterable({
    dark,
    label,
    value,              // guid string (selectedClient)
    onChange,           // expects guid string
    listItems,
    width,
    minWidth,
    marginRight,
    center,
    required,
    allowNull
}) {

    // Convert selected guid -> option object for Autocomplete
    const selectedOption =
        listItems.find(o => o.value === value) ?? null;

    const options = allowNull
        ? [{ label: "", value: "" }, ...listItems] // or value: null if you prefer
        : listItems;

    return (
        <FormControl
            className={dark && "dark"}
            color="secondary"
            variant="standard"
            sx={{
                width: width ?? "100%",
                minWidth: minWidth ?? undefined,
                mt: center ? "auto" : 1,
                mb: 0.5,
                mr: marginRight ?? 0
            }}
        >
            <Autocomplete
                options={options}
                value={selectedOption}
                onChange={(_, newOption) => onChange(newOption?.value || "")}
                getOptionLabel={(o) => o?.label ?? ""}
                isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label={label}
                        required={required}
                    />
                )}
            />
        </FormControl>
    );
}
